import React from 'react'
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/input/containers/input.container';
import storePersist from '../../../../../../redux/storePersist';
import { selectListItems } from '../../../../../../redux/library/selector';
import { useSelector } from 'react-redux';

export default function GatewayBasicInfoComponent({ dbas, handleFormChange, selectedGateway, handleInnerFormChange, domainDetails, networks, checkFQDNStatus }: any) {
  const countries = storePersist.get('countries').current?.items;
  const libraryData = useSelector(selectListItems)
  const Cities = [
    { Id: 1, Name: "Bangalore", StdCode: "std:080", StateCode: 105, CountryCode: 133 },
    { Id: 2, Name: "Chennai", StdCode: "std:044", StateCode: 105, CountryCode: 133 },
    { Id: 3, Name: "Coimbatore", StdCode: "std:0422", StateCode: 105, CountryCode: 133 },
    { Id: 4, Name: "Madurai", StdCode: "std:0452", StateCode: 105, CountryCode: 133 },
    { Id: 5, Name: "Salem", StdCode: "std:0427", StateCode: 105, CountryCode: 133 },
    { Id: 6, Name: "Tirupur", StdCode: "std:0421", StateCode: 105, CountryCode: 133 },
    { Id: 7, Name: "Erode", StdCode: "std:0424", StateCode: 105, CountryCode: 133 },
    { Id: 8, Name: "Trichy", StdCode: "std:0431", StateCode: 105, CountryCode: 133 },
    { Id: 9, Name: "Virudhunagar", StdCode: "std:04562", StateCode: 105, CountryCode: 133 },
    { Id: 10, Name: "Trichur", StdCode: "std:0487", StateCode: 93, CountryCode: 133 },
  ]
  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Name',

                )
              }}
              type="text"
              value={selectedGateway?.Name}
            />
            <InputContainer
              label="UniqueId"
              name="UniqueId"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'UniqueId',

                )
              }}
              type="text"
              value={selectedGateway?.UniqueId}
            />
            <InputContainer
              isDisabled
              label="DBA Name"
              labelField="Name"
              list={dbas}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'DBAId',
                );
              }}
              optionName='Choose DBA'
              type="select"
              value={selectedGateway?.DBAId}
              valueField="Id"
            />
            <div className='flex flex-row justify-top items-top'>
              <InputContainer
                label="Subscriber Id"
                name="SubscriberId"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'SubscriberId',

                  )
                }}
                type="text"
                value={selectedGateway?.SubscriberId}
              />
              <div className='hover:cursor-pointer' onClick={()=>checkFQDNStatus(selectedGateway?.SubscriberId)}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} color={"#000000"} fill={"none"}>
                <path d="M17.25 3V4.33957M17.25 4.33957C17.9156 4.33957 18.5182 4.60934 18.9545 5.04551M17.25 4.33957C16.5844 4.33957 15.9818 4.60934 15.5455 5.04551M17.25 9.161V10.5M17.25 9.161C17.9158 9.161 18.5185 8.89111 18.9548 8.45477M17.25 9.161C16.5842 9.161 15.9815 8.89111 15.5452 8.45477M21 6.75L19.6607 6.75028M19.6607 6.75028C19.6607 7.41591 19.3909 8.01853 18.9548 8.45477M19.6607 6.75028C19.6607 6.08451 19.3908 5.48177 18.9545 5.04551M14.8393 6.75028L13.5 6.75M14.8393 6.75028C14.8393 6.08451 15.1092 5.48177 15.5455 5.04551M14.8393 6.75028C14.8393 7.41591 15.1091 8.01853 15.5452 8.45477M19.9017 4.09835L18.9545 5.04551M14.5984 9.40165L15.5452 8.45477M19.9017 9.40165L18.9548 8.45477M14.5984 4.09835L15.5455 5.04551" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                <path d="M13.6903 19.4567C13.5 18.9973 13.5 18.4149 13.5 17.25C13.5 16.0851 13.5 15.5027 13.6903 15.0433C13.944 14.4307 14.4307 13.944 15.0433 13.6903C15.5027 13.5 16.0851 13.5 17.25 13.5C18.4149 13.5 18.9973 13.5 19.4567 13.6903C20.0693 13.944 20.556 14.4307 20.8097 15.0433C21 15.5027 21 16.0851 21 17.25C21 18.4149 21 18.9973 20.8097 19.4567C20.556 20.0693 20.0693 20.556 19.4567 20.8097C18.9973 21 18.4149 21 17.25 21C16.0851 21 15.5027 21 15.0433 20.8097C14.4307 20.556 13.944 20.0693 13.6903 19.4567Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                <path d="M3.1903 19.4567C3 18.9973 3 18.4149 3 17.25C3 16.0851 3 15.5027 3.1903 15.0433C3.44404 14.4307 3.93072 13.944 4.54329 13.6903C5.00272 13.5 5.58515 13.5 6.75 13.5C7.91485 13.5 8.49728 13.5 8.95671 13.6903C9.56928 13.944 10.056 14.4307 10.3097 15.0433C10.5 15.5027 10.5 16.0851 10.5 17.25C10.5 18.4149 10.5 18.9973 10.3097 19.4567C10.056 20.0693 9.56928 20.556 8.95671 20.8097C8.49728 21 7.91485 21 6.75 21C5.58515 21 5.00272 21 4.54329 20.8097C3.93072 20.556 3.44404 20.0693 3.1903 19.4567Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                <path d="M3.1903 8.95671C3 8.49728 3 7.91485 3 6.75C3 5.58515 3 5.00272 3.1903 4.54329C3.44404 3.93072 3.93072 3.44404 4.54329 3.1903C5.00272 3 5.58515 3 6.75 3C7.91485 3 8.49728 3 8.95671 3.1903C9.56928 3.44404 10.056 3.93072 10.3097 4.54329C10.5 5.00272 10.5 5.58515 10.5 6.75C10.5 7.91485 10.5 8.49728 10.3097 8.95671C10.056 9.56928 9.56928 10.056 8.95671 10.3097C8.49728 10.5 7.91485 10.5 6.75 10.5C5.58515 10.5 5.00272 10.5 4.54329 10.3097C3.93072 10.056 3.44404 9.56928 3.1903 8.95671Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
              </svg>
              </div>
            </div>

            <InputContainer
              label="Subscriber Url"
              name="SubscriberUrl"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'SubscriberUrl',

                )
              }}
              type="text"
              value={selectedGateway?.SubscriberUrl}
            />
            <InputContainer
              label="Status"
              name="Status"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Status',

                )
              }}
              type="text"
              value={selectedGateway?.Status}
            />
            <InputContainer
              isDisabled
              label="Type"
              labelField="Type"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Type'
                )
              }}
              type="text"
              value={selectedGateway?.Type}

            />
            <InputContainer
              label="Domain Name"
              labelField="Name"
              list={domainDetails}
              onValueChange={(newValue: any) => {
                const valueData: any = newValue.map((option: any) => option?.value || '',)
                console.log('valueData', valueData)
                handleInnerFormChange(
                  valueData,
                  'Domains'
                )
              }}
              type="multiselect"
              valueField="Id"
              value={selectedGateway?.Domains}
            />
            <InputContainer
              label="Network Name"
              labelField="Name"
              list={networks}
              onValueChange={(newValue: any) => {
                const valueData: any = newValue.map((option: any) => option?.value)
                handleInnerFormChange(
                  valueData,
                  'Networks',
                )
              }}
              type="multiselect"
              valueField="Id"
              value={selectedGateway?.Networks}
            />
            <InputContainer
              label="Country Name"
              labelField="Name"
              list={countries}
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Country',
                );
              }}
              optionName='Choose Country'
              type="select"
              value={selectedGateway?.Country}
              valueField="Name"
            />

            <InputContainer
              label="Is Limited to Cities"
              name="IsLimitedToCities"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event,
                  'IsLimitedToCities'
                );
              }}
              type="checkbox"
              value={selectedGateway?.IsLimitedToCities}
            />

            {selectedGateway?.IsLimitedToCities ?
              <InputContainer
                label="Cities"
                labelField="Name"
                list={Cities}
                onValueChange={(newValue: any) => {
                  const valueData: any = newValue.map((option: any) => option?.value)
                  handleInnerFormChange(
                    valueData,
                    'Cities',
                  )
                }}
                type="multiselect"
                valueField="Name"
                value={selectedGateway?.Cities}
              /> : <></>}
          </div>
        }
        expandedPanel="userInfo"
        headerTitle="Basic Info"
      />

    </>
  )
}